import React from 'react';

import CommonImage from '@components/CommonImage';

const NoItemFound = ({ title, buttonTitle, onClick, isShowActionButton = true }) => {
	return (
		<div className="data-table">
			<div className="pom-empty d-flex justify-content-center align-items-center flex-column">
				<p className="medium-16 gray_dark_03">{title}</p>
				{isShowActionButton && (
					<button className="button size32 outline" onClick={onClick}>
						<CommonImage src="/icons/add_primary.svg" alt="Add icon" isStatic={true} />
						<span className="ml-1 regular-12 gray_dark_01">{buttonTitle}</span>
					</button>
				)}
			</div>
		</div>
	);
};

export default NoItemFound;
